import { Markdown } from '@components/markdown'
import type { FunctionComponent } from 'react'

import styles from './block.module.scss'

interface TextBlockProps {
    textField: string
    isCenterBlock: boolean
}

export const TextBlock: FunctionComponent<TextBlockProps> = ({
    textField = '',
    isCenterBlock = false,
}) => {
    return (
        <div>
            {textField && !isCenterBlock && (
                <div className={styles.subtitle}>
                    <Markdown
                        typeStyle={{ _: 'body-lg', md: 'body-md' }}
                        markdown={textField}
                    />
                </div>
            )}
        </div>
    )
}

export default TextBlock
